export default __webpack_public_path__ + "4ec4d6ab8b5b34414ebe60720f03ea71.png";